import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type {
  ApiSuccess,
  SmtpSettingInput,
  SmtpSettingView,
  SmtpTestResult,
} from '@app/shared';
import { apiClient } from '../../lib/api-client';

const KEY = ['settings', 'smtp'];

export function useSmtpSetting() {
  return useQuery({
    queryKey: KEY,
    queryFn: async (): Promise<SmtpSettingView> => {
      const res = await apiClient.get<ApiSuccess<SmtpSettingView>>('/settings/smtp');
      return res.data.data;
    },
  });
}

export function useUpdateSmtp() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: SmtpSettingInput): Promise<SmtpSettingView> => {
      const res = await apiClient.put<ApiSuccess<SmtpSettingView>>('/settings/smtp', input);
      return res.data.data;
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: KEY });
    },
  });
}

export function useTestSmtp() {
  return useMutation({
    mutationFn: async (): Promise<SmtpTestResult> => {
      const res = await apiClient.post<ApiSuccess<SmtpTestResult>>('/settings/smtp/test');
      return res.data.data;
    },
  });
}
